import { INotBilled } from "@nkr/store/billing";

interface IProps {
    data: INotBilled,
    onStartBilling: (donorId: number) => void
}

const BilledManuallyRow = (props: IProps) => {
    // const handleStartBilling = () => {
    //     props.onStartBilling(props.data.donor.id);
    // };

    const { transplantDate, chainId, clusterNumber, positionNumber, donor, recipient, physicianCharges, anesthesiaCharges, hospitalCharges, claimType } = props.data;
    const total = physicianCharges + anesthesiaCharges + hospitalCharges;

    return (
        <tr>
            <td>{transplantDate}</td>
            <td>{chainId}/{clusterNumber}/{positionNumber}</td>
            <td>{donor.center.alias} {donor.rdnCenterId > 0 ? <span style={{ color: 'darkred' }}>({donor.rdnCenterAlias})</span> : null}</td>
            <td>{donor.alias}</td>
            <td>{recipient.center.alias}</td>
            <td>{recipient.alias}</td>
            <td>{claimType}</td>
            <td>${total.toLocaleString('en', { minimumFractionDigits: 2 })}</td>
        </tr>
    );
}

export default BilledManuallyRow;